import React, { useState } from "react"

import Scorecard from "./Scorecard"
import Leaderboard from "./Leaderboard"
import Skins from "./Skins"
import { TeamRound, TeamRoundPlayer, Hole, HoleSkin, Round, AssetMap } from "../types"

interface TabsProps {
  holeIndex: number
  round: Round
  teamRounds: TeamRound[]
  pairing: TeamRound[]
  teamRound: TeamRound
  currentUserId: number
  skins: Map<Hole, HoleSkin>
  assets: AssetMap
  editableTeamRoundId?: number
  onScoreCellPress?: (holeIndex: number, player: TeamRoundPlayer) => void
}

export default function Tabs({
  holeIndex,
  round,
  teamRounds,
  pairing,
  teamRound,
  currentUserId,
  skins,
  assets,
  editableTeamRoundId,
  onScoreCellPress
}: TabsProps) {
  const { numberOfHoles, holes } = round
  const startsAt = new Date(round.startsAt)
  const showScorecard = startsAt < new Date() && !!teamRound
  const [activeTab, setActiveTab] = useState(showScorecard ? "scorecard" : "leaderboard")

  return (
    <div className="card">
      <div className="container">
        <Header activeTab={activeTab} setActiveTab={setActiveTab} scorecard={showScorecard} />
        <Content
          activeTab={activeTab}
          round={round}
          numberOfHoles={numberOfHoles}
          holes={holes}
          holeIndex={holeIndex}
          currentUserId={currentUserId}
          teamRound={teamRound}
          teamRounds={teamRounds}
          pairing={pairing}
          skins={skins}
          assets={assets}
          editableTeamRoundId={editableTeamRoundId}
          onScoreCellPress={onScoreCellPress}
        />
      </div>
    </div>
  )
}

interface HeaderProps {
  activeTab: string
  setActiveTab(activeTab: string): void
  scorecard: boolean
}

function Header({ activeTab, setActiveTab, scorecard }: HeaderProps) {
  return (
    <div className={scorecard ? "spark-tab-bar three-up" : "spark-tab-bar"}>
      <div className="inner">
        {scorecard ? (
          <a className={activeTab === "scorecard" ? "active" : ""} onClick={() => setActiveTab("scorecard")}>
            Scorecard
          </a>
        ) : null}
        <a className={activeTab === "leaderboard" ? "active" : ""} onClick={() => setActiveTab("leaderboard")}>
          Leaderboard
        </a>
        <a className={activeTab === "skins" ? "active" : ""} onClick={() => setActiveTab("skins")}>
          Skins
        </a>
      </div>
    </div>
  )
}

interface ContentProps {
  activeTab: string
  round: Round
  numberOfHoles: number
  holes: Hole[]
  holeIndex: number
  currentUserId: number
  teamRound: TeamRound
  teamRounds: TeamRound[]
  pairing: TeamRound[]
  skins: Map<Hole, HoleSkin>
  assets: AssetMap
  editableTeamRoundId?: number
  onScoreCellPress?: (holeIndex: number, player: TeamRoundPlayer) => void
}

function Content({
  activeTab,
  round,
  numberOfHoles,
  holes,
  holeIndex,
  currentUserId,
  teamRound,
  teamRounds,
  pairing,
  skins,
  assets,
  editableTeamRoundId,
  onScoreCellPress
}: ContentProps) {
  switch (activeTab) {
    case "scorecard":
      return (
        <>
          {pairing.map((tr) => {
            const editable = editableTeamRoundId != null && tr.id === editableTeamRoundId
            return (
              <Scorecard
                key={tr.id}
                numberOfHoles={numberOfHoles}
                holes={holes}
                holeIndex={holeIndex}
                teamRound={tr}
                onScoreCellPress={editable ? onScoreCellPress : undefined}
              />
            )
          })}
        </>
      )
    case "leaderboard":
      return (
        <Leaderboard
          currentUserId={currentUserId}
          round={round}
          teamRound={teamRound}
          teamRounds={teamRounds}
          assets={assets}
        />
      )
    case "skins":
      return <Skins skins={skins} />
  }
}
